"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WearableCategory = void 0;
const validation_1 = require("../validation");
var WearableCategory;
(function (WearableCategory) {
    WearableCategory["EYEBROWS"] = "eyebrows";
    WearableCategory["EYES"] = "eyes";
    WearableCategory["FACIAL_HAIR"] = "facial_hair";
    WearableCategory["HAIR"] = "hair";
    WearableCategory["MOUTH"] = "mouth";
    WearableCategory["UPPER_BODY"] = "upper_body";
    WearableCategory["LOWER_BODY"] = "lower_body";
    WearableCategory["FEET"] = "feet";
    WearableCategory["EARRING"] = "earring";
    WearableCategory["EYEWEAR"] = "eyewear";
    WearableCategory["HAT"] = "hat";
    WearableCategory["HELMET"] = "helmet";
    WearableCategory["MASK"] = "mask";
    WearableCategory["TIARA"] = "tiara";
    WearableCategory["TOP_HEAD"] = "top_head";
})(WearableCategory = exports.WearableCategory || (exports.WearableCategory = {}));
(function (WearableCategory) {
    WearableCategory.schema = {
        type: 'string',
        enum: Object.values(WearableCategory)
    };
    WearableCategory.validate = (0, validation_1.generateValidator)(WearableCategory.schema);
})(WearableCategory = exports.WearableCategory || (exports.WearableCategory = {}));
//# sourceMappingURL=wearable-category.js.map